import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

class MakeWorkerFavourite extends APIRequestState {
  putRequest(...params) {
    return this.ctx.sdk.post(`/favourites`, ...params);
  }
}

class DeleteWorkerFavourite extends APIRequestState {
  putRequest(id) {
    return this.ctx.sdk.delete(`/favourites/${id}`);
  }
}

class WorkerFavouriteState {
  @lazyInitialize @nonenumerable makeFavourite = new MakeWorkerFavourite(this.ctx);
  @lazyInitialize @nonenumerable deleteFavourite = new DeleteWorkerFavourite(this.ctx);

  @nonenumerable listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default WorkerFavouriteState;



// WEBPACK FOOTER //
// ./spa/state/worker-favourite.jsx